// https://developers.livechatinc.com/blog/setting-cookies-to-subdomains-in-javascript/
// little modified, set cookie on highest possible domain level (first should not be possible..)
// Cookie.set('test', '123');
export class Cookie {
    set(name, value, days) {
        var domainParts, date, expires, host;

        if (days) {
            date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toGMTString();
        }
        else {
            expires = "";
        }

        host = location.host;
        if (host.split('.').length === 1) {
            // no "." in a domain - it's localhost or something similar
            document.cookie = name + "=" + value + expires + "; path=/";
        }
        else {
            // Remember the cookie on all subdomains.
            //
            // Start with trying to set cookie to the top domain.
            // (example: if user is on foo.com, try to set
            //  cookie to domain ".com")
            //
            // If the cookie will not be set, it means ".com"
            // is a top level domain and we need to
            // set the cookie to ".foo.com"
            domainParts = host.split('.');
            var domainTest = "";
            for (var i = 0, nr = domainParts.reverse().length; i < nr; i++) {
                var addedDomainPart = i === 0 ? domainParts[i] : domainParts[i] + '.';
                domainTest = addedDomainPart + domainTest;

                // test to set it
                document.cookie = name + "=" + value + expires + "; path=/; domain=" + domainTest;
                if (this.get(name) != null && this.get(name) === value) {
                    // append "." to current domain
                    domainTest = '.' + domainTest;
                    document.cookie = name + "=" + value + expires + "; path=/; domain=" + domainTest;

                    // break out of foo loop, it did work
                    break;
                }
            }
        }
    }

    get(name) {
        var nameEq = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1, c.length);
            }

            if (c.indexOf(nameEq) === 0) return c.substring(nameEq.length, c.length);
        }
        return null;
    }

    erase(name) {
        this.set(name, '', -1);
    }
}